import { render } from "./TabList.vue?vue&type=template&id=50971a82&scoped=true"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"

import "./TabList.vue?vue&type=style&index=0&id=50971a82&scoped=true&lang=scss"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50971a82"]])

export default __exports__